// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left-navbar {
	width: 100%;
	background-color: #ffffff;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 30px 16px;
	height: 100vh;
	overflow-y: auto;
}

.left-navbar .left-navbar__logo-block {
	margin-left: 0;
	width: unset;
	padding: 0 6px;
	align-items: start;
}

.left-navbar .left-navbar__logo-block svg {
	margin-left: 10px;
}

.left-navbar__logo-block {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: start;
	width: 100%;
	gap: 4px;
	padding: 0;
}

.left-navbar__logo-block img {
	height: 33px;
	-webkit-user-select: none;
	        user-select: none;
}

.left-navbar__items-block {
	display: flex;
	flex-direction: column;
	gap: 40px;
}

.left-navbar__navigation-links-block {
	display: flex;
	flex-direction: column;
	gap: 6px;
}

.left-navbar__items-block .active::before {
	content: unset;
}

.left-navbar__items-block .nav-item {
	height: 56px;
}

.left-navbar .left-nav-link {
	justify-content: center;
}

.left-navbar.expanded .left-nav-link {
	justify-content: start;
}

.left-navbar__items-block .left-nav-link {
	display: flex;
	width: 100%;
	height: 100%;
	align-items: center;
	gap: 10px;
	padding: 0 16px;
	border-radius: 6px;
	font-size: 16px;
	line-height: 23px;
	color: #666666 !important;
}

.left-navbar__items-block .left-nav-link:hover {
	background: #f2f2f2;
}

.left-navbar__items-block .left-nav-link.active {
	color: #ffffff !important;
	background: #4db8ff;
	font-weight: 400 !important;
}

.left-navbar__billing-dropdown-wrapper {
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.navbar-settings {
	height: 55px;
	padding: 0;
	transition: all 0.8s !important;
}

.navbar-settings:hover {
	background: linear-gradient(90deg,
			rgba(66, 148, 209, 1) 0%,
			rgba(36, 198, 235, 1) 100%);
	transition: all 0.8s !important;
}

.navbar-settings-link-text {
	color: #f3faff;
	font-size: 1.3rem;
	font-weight: 600;
	margin-left: 5px;
}

.navbar-settings:hover svg {
	color: #fff;
}

.navbar-settings-link {
	padding-left: 30px;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
}

.left-nav-dropdown-menu-billing {
	left: 0 !important;
	padding: 8px !important;
	background-color: #ffffff !important;
	flex-direction: column;
}


.user-header__help {
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 6px;
	padding: 4px 8px;
	border: 1px solid transparent;
	cursor: pointer;
	color: #FFFFFF;
	width: fit-content;
	position: absolute;
	right: 16px;
	bottom: 16px;
	background-color: #4db8ff;
	border: 1px solid #e6e6e6;
	height: 40px;
	min-width: 40px;
	z-index: 10;
}

.user-header__help-guides {
	width: 0px;
	opacity: 0;
	font-size: 14px;
	line-height: 17px;
	font-weight: 500;
}

.user-header__help:hover .user-header__help-guides {
	width: fit-content;
	opacity: 1;
	transition: 0.3s;
}

.user-header__help:hover {
	transition: 0.3s;
	gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/LeftNav/LeftNav.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,yBAAyB;CACzB,aAAa;CACb,sBAAsB;CACtB,8BAA8B;CAC9B,kBAAkB;CAClB,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,sBAAsB;CACtB,WAAW;CACX,QAAQ;CACR,UAAU;AACX;;AAEA;CACC,YAAY;CACZ,yBAAiB;SAAjB,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,SAAS;CACT,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,YAAY;CACZ,UAAU;CACV,+BAA+B;AAChC;;AAEA;CACC;;8BAE6B;CAC7B,+BAA+B;AAChC;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,uBAAuB;CACvB,oCAAoC;CACpC,sBAAsB;AACvB;;;AAGA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,gBAAgB;CAChB,6BAA6B;CAC7B,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,yBAAyB;CACzB,YAAY;CACZ,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,UAAU;CACV,UAAU;CACV,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,QAAQ;AACT","sourcesContent":[".left-navbar {\n\twidth: 100%;\n\tbackground-color: #ffffff;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\tpadding: 30px 16px;\n\theight: 100vh;\n\toverflow-y: auto;\n}\n\n.left-navbar .left-navbar__logo-block {\n\tmargin-left: 0;\n\twidth: unset;\n\tpadding: 0 6px;\n\talign-items: start;\n}\n\n.left-navbar .left-navbar__logo-block svg {\n\tmargin-left: 10px;\n}\n\n.left-navbar__logo-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: start;\n\twidth: 100%;\n\tgap: 4px;\n\tpadding: 0;\n}\n\n.left-navbar__logo-block img {\n\theight: 33px;\n\tuser-select: none;\n}\n\n.left-navbar__items-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 40px;\n}\n\n.left-navbar__navigation-links-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 6px;\n}\n\n.left-navbar__items-block .active::before {\n\tcontent: unset;\n}\n\n.left-navbar__items-block .nav-item {\n\theight: 56px;\n}\n\n.left-navbar .left-nav-link {\n\tjustify-content: center;\n}\n\n.left-navbar.expanded .left-nav-link {\n\tjustify-content: start;\n}\n\n.left-navbar__items-block .left-nav-link {\n\tdisplay: flex;\n\twidth: 100%;\n\theight: 100%;\n\talign-items: center;\n\tgap: 10px;\n\tpadding: 0 16px;\n\tborder-radius: 6px;\n\tfont-size: 16px;\n\tline-height: 23px;\n\tcolor: #666666 !important;\n}\n\n.left-navbar__items-block .left-nav-link:hover {\n\tbackground: #f2f2f2;\n}\n\n.left-navbar__items-block .left-nav-link.active {\n\tcolor: #ffffff !important;\n\tbackground: #4db8ff;\n\tfont-weight: 400 !important;\n}\n\n.left-navbar__billing-dropdown-wrapper {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n}\n\n.navbar-settings {\n\theight: 55px;\n\tpadding: 0;\n\ttransition: all 0.8s !important;\n}\n\n.navbar-settings:hover {\n\tbackground: linear-gradient(90deg,\n\t\t\trgba(66, 148, 209, 1) 0%,\n\t\t\trgba(36, 198, 235, 1) 100%);\n\ttransition: all 0.8s !important;\n}\n\n.navbar-settings-link-text {\n\tcolor: #f3faff;\n\tfont-size: 1.3rem;\n\tfont-weight: 600;\n\tmargin-left: 5px;\n}\n\n.navbar-settings:hover svg {\n\tcolor: #fff;\n}\n\n.navbar-settings-link {\n\tpadding-left: 30px;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.left-nav-dropdown-menu-billing {\n\tleft: 0 !important;\n\tpadding: 8px !important;\n\tbackground-color: #ffffff !important;\n\tflex-direction: column;\n}\n\n\n.user-header__help {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 6px;\n\tpadding: 4px 8px;\n\tborder: 1px solid transparent;\n\tcursor: pointer;\n\tcolor: #FFFFFF;\n\twidth: fit-content;\n\tposition: absolute;\n\tright: 16px;\n\tbottom: 16px;\n\tbackground-color: #4db8ff;\n\tborder: 1px solid #e6e6e6;\n\theight: 40px;\n\tmin-width: 40px;\n\tz-index: 10;\n}\n\n.user-header__help-guides {\n\twidth: 0px;\n\topacity: 0;\n\tfont-size: 14px;\n\tline-height: 17px;\n\tfont-weight: 500;\n}\n\n.user-header__help:hover .user-header__help-guides {\n\twidth: fit-content;\n\topacity: 1;\n\ttransition: 0.3s;\n}\n\n.user-header__help:hover {\n\ttransition: 0.3s;\n\tgap: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
